import { useProjectSettingsContext } from "components/Settings/SettingsProvider";

import type { Command } from "../../types";

export const useEnvironmentVariablesCommand = (): Command => {
  const { setVisibility, setActiveTab } = useProjectSettingsContext();

  return {
    id: "codesandbox.settings.env",
    name: "Configure Environment Variables",
    subtitle: "Configure Secrets",
    section: "Settings",
    perform: () => {
      setVisibility(true);
      setActiveTab("env");
    },
  };
};
